/**
 * NutriKit Contact - progressive enhancement.
 * Shows the "Order number" field only when subject = "Question commande".
 * Pure JS, no dependencies.
 */
(function () {
  'use strict';

  function init() {
    var subject = document.getElementById('ContactSubject');
    var orderField = document.querySelector('.nutrikit-contact__field--order');
    if (!subject || !orderField) return;

    var triggerValue = orderField.dataset.showWhen || 'Question commande';

    function update() {
      if (subject.value === triggerValue) {
        orderField.removeAttribute('hidden');
      } else {
        orderField.setAttribute('hidden', '');
      }
    }

    subject.addEventListener('change', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
